import { Button, TextField, Typography } from '@mui/material';
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import PasswordStrengthReport from '@sophocles/components/PasswordStrengthReport';
import ButtonBox from '@sophocles/views/auth/forms/ButtonBox';

function InitialPasswordForm({ error, isSubmitting, onSubmit, onCancel, verifyPassword }) {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmationPassword, setConfirmationPassword] = useState('');

  let isPasswordValid = true;
  const passwordStatus = verifyPassword(password);
  if (passwordStatus) {
    isPasswordValid = passwordStatus.isValid;
  }

  const passwordsMatch = password === confirmationPassword;

  const handleSubmit = event => {
    event.preventDefault();
    onSubmit(password);
  };

  const handleCancel = event => {
    event.preventDefault();
    setPassword('');
    setConfirmationPassword('');
    onCancel();
  };

  return (
    <Fragment>
      <Typography variant="subtitle2" color="gray" align="center" sx={{ mb: '32px', textAlign: 'center' }}>
        {t('auth.initialPasswordIntro', 'You must set your password to continue logging in.')}
      </Typography>
      <form style={{ display: 'flex', flexDirection: 'column' }} onSubmit={handleSubmit}>
        <TextField
          size="small"
          type="password"
          placeholder="Password"
          label="Password"
          name="password"
          autoComplete="new-password"
          value={password}
          error={error}
          onChange={event => setPassword(event.target.value)}
          disabled={isSubmitting}
          sx={{ mb: 2 }}
        />

        <TextField
          size="small"
          type="password"
          placeholder={t('auth.verifyPassword', 'Verify Password')}
          label={t('auth.confirmationPassword', 'Confirmation Password')}
          name="confirmation-password"
          autoComplete="new-password"
          value={confirmationPassword}
          error={error}
          onChange={event => setConfirmationPassword(event.target.value)}
          disabled={isSubmitting}
          sx={{ mb: 2 }}
        />

        {passwordStatus ? <PasswordStrengthReport report={passwordStatus.metrics} /> : null}

        <ButtonBox sx={{ px: 4, my: 2 }}>
          <Button
            variant="contained"
            disabled={!isPasswordValid || !passwordsMatch || isSubmitting}
            color="primary"
            type="submit"
            fullWidth
          >
            {t('actions.submit', 'Submit')}
          </Button>
          <Button
            variant="contained"
            color="error"
            type="cancel"
            disabled={isSubmitting}
            fullWidth
            onClick={handleCancel}
          >
            {t('actions.cancel', 'Cancel')}
          </Button>
        </ButtonBox>
      </form>
    </Fragment>
  );
}

export default InitialPasswordForm;
